// Recuento final del festival: estado del cierre + resumen personal.
const sessionHeaders = () => {
  const sessionToken = localStorage.getItem('nacanaca-session') || '';
  if (!sessionToken) {
    const error = new Error('Sin sesión de jugador.');
    error.status = 401;
    throw error;
  }
  return { Accept: 'application/json', Authorization: `Bearer ${sessionToken}` };
};

async function readJson(response) {
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export async function fetchReview() {
  return readJson(await fetch('/api/review', { headers: sessionHeaders() }));
}

// Marca en servidor que el jugador ya vio su review (apertura automática única).
export async function markReviewSeen() {
  return readJson(await fetch('/api/review/seen', { method: 'POST', headers: sessionHeaders() }));
}
